import React, { useState, useRef, useEffect } from "react";
import { FaCheckCircle, FaPrint, FaUtensils } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import BookingSlip from "../components/BookingSlip";

const BookingSummary = ({ data, onReset, onEdit }) => {
  const isEditMode = Boolean(data.Id);
  const [confirmed, setConfirmed] = useState(false);
  const [taxes, setTaxes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [eventTypes, setEventTypes] = useState([]);
  const printRef = useRef();
  const navigate = useNavigate();
  const [servicesList, setServicesList] = useState([]);
const API_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
  const fetchEventTypes = async () => {
    const res = await fetch(`${API_URL}/api/event-types`);
    const data = await res.json();
    setEventTypes(data);
  };  

  fetchEventTypes();
}, []);


useEffect(() => {
  fetch(`${API_URL}/api/services`)
    .then(res => res.json())
    .then(setServicesList);
}, []);

const serviceFlags = {};

servicesList.forEach(service => {
  const exists = data.services?.some(s => s.id === service.Id);

  if (exists) {
    const key = service.ServiceName.toLowerCase().replace(/\s/g, "");

    // map to slip keys
    if (key.includes("catering")) serviceFlags.catering = true;
    if (key.includes("decoration")) serviceFlags.decoration = true;
    if (key.includes("stage")) serviceFlags.stageSetup = true;
    if (key.includes("dj")) serviceFlags.dj = true;
    if (key.includes("photo")) serviceFlags.photography = true;
    if (key.includes("parking")) serviceFlags.parking = true;
  }
});

  /* ================= PRINT FUNCTION ================= */
  useEffect(() => {
    const fetchTaxes = async () => {
      try {
        const res = await fetch(`${API_URL}/api/tax/active`);
        const data = await res.json();
        setTaxes(data);
        console.log("TAX API RESPONSE:", data);
      } catch (err) {
        console.error("Failed to load taxes");
      }
    };

    fetchTaxes();
  }, []);


  const handlePrint = () => {
    const content = printRef.current.innerHTML;

    const printWindow = window.open("", "", "width=900,height=650");

    printWindow.document.write(`
    <html>
      <head>
        <title>Booking Slip</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 40px; }
        </style>
      </head>
      <body>
        ${content}
      </body>
    </html>
  `);

    printWindow.document.close();

    // WAIT for images to load
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }, 300);
    };
  };
  // ===== PAYMENT CALCULATION =====

  const subtotal = Number(data.total) || 0;
  const advancePaid = Number(data.advance) || 0;

  /* CALCULATE TAX FROM DB */
  const taxBreakdown = data.TaxBreakup
  ? JSON.parse(data.TaxBreakup)
  : taxes.map(t => ({
      name: t.TaxName,
      percent: t.Percentage,
      amount: (subtotal * t.Percentage) / 100
    }));

  // const totalTax = taxBreakdown.reduce((sum, t) => sum + t.amount, 0);

  // const grandTotal = subtotal + totalTax;

  const calculatedTax = taxBreakdown.reduce((sum, t) => sum + t.amount, 0);

const grandTotal =
  data.GrandTotal ||
  subtotal + calculatedTax;
const totalTax = data.TotalTax || 0;

  const minAdvance = grandTotal * 0.3;


  const formatSqlTime = (time) => {
  if (!time) return null;

  const [h, m] = time.split(":");

  return `${h}:${m}:00.000`;
};
  /* ================= SAVE FUNCTION ================= */

const saveBooking = async () => {
  const payload = {
    ...data,
    startTime: formatSqlTime(data.startTime),
    endTime: formatSqlTime(data.endTime),
    EventTypeId: data.eventTypeId,
    HallId: data.hallId,
    PackageId: data.packageId,
  };

  const url = data.Id
    ? `${API_URL}/api/bookings/${data.Id}`
    : `${API_URL}/api/bookings`;

  const method = data.Id ? "PUT" : "POST";

  const response = await fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to save booking");
  }

  const result = await response.json();   // ✅ MUST ADD
  return result;                          // ✅ MUST RETURN
};

  const handleConfirm = async () => {
    if (advancePaid > minAdvance) {
      setError(
        `Minimum advance should be ₹${minAdvance.toFixed(0)} (30% of total)`,
      );
      return;
    }

    try {
      setLoading(true);
      setError("");
      await saveBooking();
      setConfirmed(true);
    } catch (err) {
      setError("Failed to save booking. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmAndMenu = async () => {
    try {
      setLoading(true);
      setError("");
      await saveBooking();
      navigate("/menu");
    } catch (err) {
      setError("Failed to save booking.");
    } finally {
      setLoading(false);
    }
  };

const handleConfirmAndPrint = async () => {
  if (advancePaid > minAdvance) {
    setError(
      `Minimum advance should be ₹${minAdvance.toFixed(0)} (30% of total)`
    );
    return;
  }

  try {
    setLoading(true);
    setError("");

    const result = await saveBooking();

    console.log("API RESULT:", result); // 🔍 debug

    data.bookingCode = result.bookingCode;

    setTimeout(() => {
      if (printRef.current) {
        handlePrint();
      }
      setConfirmed(true);
    }, 200);
  } catch (err) {
    console.error("ERROR:", err);
    setError("Failed to save booking.");
  } finally {
    setLoading(false);
  }
};

const eventName = eventTypes.find(
  e => e.Id == data.eventTypeId
)?.EventName;

  /* ================= SUCCESS SCREEN ================= */

  if (confirmed) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-100 via-white to-emerald-100 flex justify-center items-center p-6">
        <div className="bg-white shadow-2xl rounded-3xl w-full max-w-2xl p-10 text-center">
          <FaCheckCircle className="text-emerald-500 text-6xl mx-auto mb-4" />

          <h2 className="text-3xl font-bold text-blue-700 mb-4">
            {isEditMode
  ? "Booking Successfully Updated"
  : "Booking Successfully Confirmed"}
          </h2>

          <p className="text-gray-600 mb-6">
            Thank you, <strong>{data.fullName}</strong>.
          </p>

          <button
            onClick={onReset}
            className="bg-gradient-to-r from-blue-600 to-emerald-500 text-white px-6 py-3 rounded-2xl hover:scale-105 transition"
          >
            Make Another Booking
          </button>
        </div>
      </div>
    );
  }

  /* ================= PREVIEW SCREEN ================= */

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-white to-emerald-100 flex justify-center p-6">
      <div className="bg-white shadow-2xl rounded-3xl w-full max-w-4xl p-10">
        <h2 className="text-3xl font-bold text-blue-700 text-center mb-8">
  {isEditMode ? "Edit Booking Preview" : "New Booking Preview"}
</h2>

        {/* Preview Grid */}
        <div className="grid md:grid-cols-2 gap-4 text-sm">
          <PreviewItem label="Full Name" value={data.fullName} />
          <PreviewItem label="Mobile" value={data.mobile} />
          <PreviewItem label="Email" value={data.email} />
          <PreviewItem label="Event Type" value={eventName} />
          <PreviewItem
            label="Event Date"
            value={new Date(data.eventDate).toLocaleDateString("en-GB")}
          />
          <PreviewItem label="Guests" value={data.guests} />
          <PreviewItem label="Subtotal" value={`₹${subtotal}`} />
          {taxBreakdown.map((tax, i) => (
            <PreviewItem
              key={i}
              label={`${tax.name || "GST"} (${tax.percent}%)`}
              value={`₹${tax.amount.toFixed(2)}`}
            />
          ))}

          <PreviewItem
            label="Grand Total"
            value={`₹${grandTotal.toFixed(2)}`}
          />
          <PreviewItem
            label="Minimum Advance (30%)"
            value={`₹${minAdvance.toFixed(2)}`}
          />
        </div>

        {error && <p className="text-red-600 mt-6 text-center">{error}</p>}

        {/* ACTION BUTTONS */}
        <div className="grid md:grid-cols-4 gap-4 mt-10">

  <button
    onClick={onEdit}
    className="bg-gray-400 text-white py-3 rounded-2xl hover:bg-gray-500 transition"
  >
    {isEditMode ? "Back to Edit" : "Edit"}
  </button>

 <button
  onClick={handleConfirmAndPrint}
  disabled={loading}
  className="flex items-center justify-center gap-2 bg-indigo-500 text-white py-3 rounded-2xl hover:bg-indigo-600 transition disabled:opacity-50"
>
  <FaPrint />
  {loading ? "Saving..." : "Confirm & Print"}
</button>

  <button
    onClick={handleConfirm}
    disabled={loading}
    className="bg-emerald-500 text-white py-3 rounded-2xl hover:bg-emerald-600 transition disabled:opacity-50"
  >
    {loading
      ? "Saving..."
      : isEditMode
      ? "Update Booking"
      : "Confirm Booking"}
  </button>

  <button
    onClick={handleConfirmAndMenu}
    disabled={loading}
    className="flex items-center justify-center gap-2 bg-blue-600 text-white py-3 rounded-2xl hover:bg-blue-700 transition disabled:opacity-50"
  >
    <FaUtensils />
    {isEditMode ? "Update & Menu" : "Confirm & Menu"}
  </button>

</div>

        {/* Hidden Printable Slip */}
        <div className="hidden">
          <BookingSlip
  ref={printRef}
  data={{
    ...data,
    taxBreakdown,
    

     // ✅ SERVICES FIX
    ...serviceFlags,

    // ✅ FIX EVENT TYPE
    eventType:
      data.eventType ||
      eventTypes.find(e => e.Id == data.eventTypeId)?.EventName ||
      data.EventType,

    // ✅ FIX HALL
    hall:
      data.hall ||
      data.Hall ||
      (typeof data.hallId === "number"
        ? `Hall ${data.hallId}`
        : data.hallId),
  }}
/>
        </div>
      </div>
    </div>
  );
};

export default BookingSummary;

const PreviewItem = ({ label, value }) => (
  <div className="bg-gray-50 p-3 rounded-xl">
    <p className="text-gray-500 text-xs">{label}</p>
    <p className="font-semibold text-gray-800">{value || "-"}</p>
  </div>
);
